import { SearchViewWithConfirmation } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent, useCallback } from 'react'

import { Address } from '../../../../domain'
import { TKeyBuilder } from '../../../internationalisation'
import { AddressSearchView } from './AddressSearchView'

interface AddressFinderProps {
  initialValue?: Address
  onSelect: (address: Address | undefined) => void
  tKey: TKeyBuilder
  tName: string
  t: TFunction
}

export const AddressFinder: FunctionComponent<AddressFinderProps> = ({
  initialValue,
  onSelect,
  tKey,
  tName,
  t,
}) => {
  const renderConfirmationLabel = useCallback(
    ({ pcaId, label }: Address) => <pre key={pcaId}>{label}</pre>,
    [],
  )
  const renderSearch = useCallback(
    (f) => <AddressSearchView onSelect={f} tKey={tKey} tName={tName} t={t} />,
    [],
  )

  return (
    <SearchViewWithConfirmation
      initialValue={initialValue}
      onSelect={onSelect}
      renderConfirmationLabel={renderConfirmationLabel}
      renderSearch={renderSearch}
    />
  )
}
